module.exports = __webpack_public_path__ + "static/img/new1-CfyVfWeL.961e1f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new1-CfyVfWeL.png
// module id = Dac8
// module chunks = 16